import {
  RESEND_MESSAGES
} from "@/store/messages/actions";

export default {
  data() {
    return {
      isSending: false,
    }
  },
  methods: {
    messageTitleClass(message) {
      if (!!message.is_failed) {
        return 'error white--text';
      }

      if (!!message.is_sent) {
        return 'success white--text';
      }

      return 'blue-grey lighten-5'
    },
    resend(id) {
      this.isSending = true;
      this.$store.dispatch(RESEND_MESSAGES, {id}).then(() => {
        this.isSending = false;
        this.showNotification(this.$lang('main.words.succeeded'), 'success');
      });
    },
    openMessage(id) {
      this.$emit('opening', id);
    },
    openEditing(id) {
      this.$emit('editing', id);
    },
    openRemoving(id) {
      this.$emit('removing', id);
    },
    reply(id) {
      this.$emit('reply', id);
    },
    getSendTime(message) {
      if (message.planned_at) {
        return this.$toDateTimeFormat(message.planned_at);
      }

      if (message.is_sent) {
        return this.$toDateTimeFormat(message.updated_at);
      }

      return this.$toDateTimeFormat(message.updated_at);
    },
  },
}